/**
 * Replaces non-breaking spaces (both the `&nbsp;` entity and the raw U+00A0
 * character) with regular spaces.
 *
 * Quill 2 serialises **every** regular space as `&nbsp;` when the document is
 * read via `getSemanticHTML()`, which is the value `react-quill-new` hands to
 * `onChange`. A paragraph made of non-breaking spaces is a single unbreakable
 * token, so the text either overflows its container or is chopped mid-word, and
 * sent emails break at the wrong positions (Bug #11522).
 *
 * `AixQuill` applies this to the editor output, so consumers get regular
 * spaces. Use it directly when rendering rich text that may still come from
 * legacy data written before that fix.
 */
export const normalizeNonBreakingSpaces = (html: string): string =>
  html.replace(/&nbsp;|\u00A0/g, ' ');
